<template>
  <!-- 任教信息 -->
  <div class="person-info">
    <h3>
      <i></i>
      <span>任教信息</span>
      <div class="edit" @click="editInfo" v-if="!onEdit && hasFinished"><img src="../../assets/edit_icon.png"> 编辑</div>
    </h3>
    <div class="person-box">
      <section class="checkbox-sec">
        <label class="tit">任&nbsp;&nbsp;教&nbsp;&nbsp;年&nbsp;&nbsp;级：</label>
        <div class="con grade-con">
          <el-checkbox-group v-model="teachGrade" v-if="!hasFinished || onEdit" @change="getGrade">
            <el-checkbox v-for="(grade, key) in workInfo.dicTeachGrades" :key="key" :label="key">{{grade}}</el-checkbox>
          </el-checkbox-group>
          <div class="txt" v-if="!onEdit && hasFinished">{{teachGradeName}}</div>
        </div>
        <span class="error" v-if="gradeErr">请选择任教年级</span>
      </section>
      <section class="busniss-sec">
        <label class="tit">周课时数(节)：</label>
        <div class="con">
          <el-select v-model="classHour" placeholder="请选择" v-if="!hasFinished || onEdit" @change="getWeekHour">
            <el-option v-for="week in weekHoursOptions" :key="week.id" :label="week.label" :value="week.label"></el-option>
          </el-select>
          <div class="txt" v-if="!onEdit && hasFinished">{{classHour}}节</div>
        </div>
        <span class="error" v-if="classErr">请选择周课时数</span>
      </section>
      <section class="checkbox-sec speciality-sec">
        <label class="tit">教&nbsp;&nbsp;学&nbsp;&nbsp;特&nbsp;&nbsp;长：</label>
        <div class="con">
          <el-checkbox label="0" v-model="isNullSpec"  v-if="!hasFinished || onEdit" @change="nullSpecialityChecked">无</el-checkbox>
          <el-checkbox-group v-model="speciality" v-if="!hasFinished || onEdit" @change="getSpeciality">
            <el-checkbox v-for="(spec, key) in workInfo.dicTeachFortes" :key="key" :label="key" v-if="key != '0'">{{spec}}</el-checkbox>
          </el-checkbox-group>
          <div class="txt" v-if="!onEdit && hasFinished">{{specialityName}}</div>
        </div>
        <span class="error" v-if="specialityErr">请选择教学特长</span>
      </section>
      <section class="btn" v-if="!hasFinished || onEdit">
        <label class="tit">&nbsp;</label>
        <div class="con">
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import api from '../../utils/api'
import datas from '../../utils/data.js'
export default {
  props: ['workInfo'],
  data () {
    return {
      hasFinished: this.workInfo.finishStatus, // 是否已经完成编辑
      teachGrade: [],
      classHour: '',
      teachGradeName: '',
      weekHoursOptions: datas.weekHoursOptions,
      speciality: [],
      specialityName: '',
      specialityNull: {},
      isNullSpec: false,
      // 错误提示
      gradeErr: false,
      classErr: false,
      specialityErr: false,
      // 编辑
      onEdit: false
    }
  },
  mounted () {
    // 未提交信息
    let loaclTeachInfo = window.sessionStorage.getItem('loaclTeachInfo')
    if (loaclTeachInfo) {
      let info = JSON.parse(loaclTeachInfo)
      this.hasFinished = info.finishStatus
      this.teachGradeName = info.gradeName
      this.classHour = info.classHour
      this.specialityName = info.specialityName
    } else if (this.workInfo.teachGradesNames.length > 0) {
      this.teachGradeName = this.arrToStr(this.workInfo.teachGradesNames)
      this.classHour = this.workInfo.weekLessons
      this.specialityName = this.arrToStr(this.workInfo.teachForteNames)
    }
    this.userId = window.sessionStorage.getItem('userId')
  },
  methods: {
    // 任教年级
    getGrade (val) {
      // 年级取值
      if (val.length > 0) {
        let gradeName = []
        for (let i = 0; i < val.length; i++) {
          for (let j in this.workInfo.dicTeachGrades) {
            if (val[i] === j) {
              gradeName.push(this.workInfo.dicTeachGrades[j])
            }
          }
        }
        this.teachGradeName = this.arrToStr(gradeName)
      }
      this.gradeErr = false
    },
    // 周课时数
    getWeekHour (val) {
      this.classErr = false
    },
    // 教学特长
    nullSpecialityChecked (val) {
      if (val) {
        this.speciality = ['0']
        this.specialityName = this.arrToStr(['无'])
        this.specialityErr = false
      } else {
        this.speciality = []
        this.isNullSpec = false
      }
    },
    // 教学特长2
    getSpeciality (val) {
      let index = val.indexOf('0')
      if (index > -1) {
        val.splice(index, 1)
      }
      // 教学特长取值
      if (val.length > 0) {
        let specialityName = []
        for (let i = 0; i < val.length; i++) {
          for (let j in this.workInfo.dicTeachFortes) {
            if (val[i] === j) {
              specialityName.push(this.workInfo.dicTeachFortes[j])
            }
          }
        }
        this.specialityName = this.arrToStr(specialityName)
      }
      this.specialityErr = false
      this.isNullSpec = false
    },
    // 数组转字符串
    arrToStr (arr) {
      let newStr = ''
      if (arr.length > 0) {
        newStr = (arr.join('，')).replace(/\"/g, '')
        newStr = newStr.replace(/\'/g, '')
        return newStr
      }
    },
    // 数组元素字符转数字
    arrStrToNum (arr) {
      let newArr = []
      if (arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          newArr.push(Number(arr[i]))
        }
        return newArr
      }
    },
    // 提交
    onSubmit () {
      let _this = this
      if (_this.teachGrade.length <= 0) {
        _this.gradeErr = true
        return false
      }
      if (_this.classHour === '') {
        _this.classErr = true
        return false
      }
      if (_this.speciality.length <= 0) {
        _this.specialityErr = true
        return false
      }

      // 数据处理
      let workInfo = {
        userId: _this.userId,
        teachGrades: _this.arrStrToNum(_this.teachGrade),
        weekLessons: _this.classHour,
        teachForte: _this.arrStrToNum(_this.speciality),
        finishStatus: false
      }
      api.post('SaveSZTeacherPersonalInfoRequest', {
        part: 4,
        workInfo: workInfo
      }, res => {
        console.log(res)
        _this.$message({
          message: '任教信息保存成功',
          type: 'success'
        })
        // 本地信息存储
        let loaclTeachInfo = {
          finishStatus: true,
          gradeName: _this.teachGradeName,
          specialityName: _this.specialityName,
          classHour: _this.classHour
        }
        window.sessionStorage.setItem('loaclTeachInfo', JSON.stringify(loaclTeachInfo))
        _this.hasFinished = true
        if (!_this.onEdit) {
          _this.$emit('hasFinish', 3)
        } else {
          _this.onEdit = false
        }
      })
    },
    // 编辑
    editInfo () {
      console.log('edit')
      this.onEdit = true
      this.teachGrade = this.getKeyArr((this.teachGradeName).split('，'), this.workInfo.dicTeachGrades)
      this.classHour = this.classHour
      if (this.specialityName === '无') {
        this.isNullSpec = true
      } else {
        this.speciality = this.getKeyArr((this.specialityName).split('，'), this.workInfo.dicTeachFortes)
      }
    },
    // 根据value获取key
    getKeyArr (valueArr, valueObj) {
      let keyArr = []
      for (let i = 0; i < valueArr.length; i++) {
        for (let j in valueObj) {
          if (valueArr[i] === valueObj[j]) {
            keyArr.push(j)
          }
        }
      }
      return keyArr
    }
  }
}
</script>
<style scoped>
  .person-info h3 {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: normal;
  }
  .person-info h3 i {
    width: 2px;
    height: 16px;
    background: #FE793A;
    margin-right: 10px;
  }

  .person-info h3 span {
    flex: 1;
  }

  .person-info h3 .edit {
    color: #FE793A;
    font-size: 12px;
    cursor: pointer;
  }

  .person-info h3 .edit img {
    width: 12px;
    height: 12px;
    vertical-align: middle;
    margin-bottom: 3px;
  }
  .person-box {
    margin-top: 24px;
  }
  .person-box section {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .person-box section .tit {
    width: 95px;
    font-size: 14px;
    color: #333;
  }
  .person-box section .con {
    width: 230px;
    margin-left: 5px;
  }
  .person-box section .txt {
    font-size: 14px;
  }
  .person-box section .error {
    width: 345px;
    text-align: left;
    font-size: 12px;
    color: #ff0000;
  }
  .person-box section.checkbox-sec .con {
    width: 400px;
  }
  .person-box section.checkbox-sec .con.grade-con {
    width: 300px;
  }
  .person-box section.checkbox-sec .con .el-checkbox-group {
    display: inline;
  }
  .person-box section.checkbox-sec .error {
    width: 160px;
  }
  .person-box section.checkbox-sec .el-checkbox {
    margin-bottom: 10px;
  }
  .person-box section.speciality-sec .con {
    width: 360px;
  }
  .person-box section.speciality-sec .error {
    width: 120px;
  }
  .person-box section.speciality-sec .el-checkbox {
    margin-bottom: 0;
  }
  .person-box section.btn {
    margin-top: 40px;
  }
  .w35 {
    width: 35.5%;
  }
</style>
